import * as React from 'react'

import Grid            from '@material-ui/core/Grid/Grid'
import { withFormik }  from 'formik'
import { object, ref } from 'yup'

import { PasswordField }  from '../atoms'
import {
  genValueMapper,
  i18nErrorCodes, mapFormikToMuiProps,
  proxyFormikSubmission,
}                         from './form-utils'
import { passwordSchema } from './schemas/formatSchemas'
import { asFormStep }     from './wrappers'

const { required, mustBeIdentical } = i18nErrorCodes

const validationSchema = object().shape({
  password:             passwordSchema.required(required),
  passwordConfirmation: passwordSchema
                          .oneOf([ ref('password') ], mustBeIdentical)
                          .required(required),
})

const defaults = {
  password:             '',
  passwordConfirmation: '',
}

const CredentialsChunk = props => {
  const { touched, errors } = props

  let manipulatedProps

  if (
    !touched.password
    || !touched.passwordConfirmation
    && errors.password === mustBeIdentical
  ) {
    manipulatedProps = {
      ...props,
      errors: {
        ...props.errors,
        password:             undefined,
        passwordConfirmation: undefined,
      }
    }
  } else {
    manipulatedProps = props
  }

  const mapper = mapFormikToMuiProps(manipulatedProps)

  return (
    <>
      <Grid
        container
        direction={'column'}
        spacing={24}
      >
        <Grid item>
          <PasswordField
            fullWidth
            {...mapper('password')}
          />
        </Grid>
        <Grid item>
          <PasswordField
            fullWidth
            {...mapper('passwordConfirmation')}
          />
        </Grid>
      </Grid>
    </>
  )
}

const formikConfig = {
  validationSchema,
  mapPropsToValues: genValueMapper(defaults),
  handleSubmit:     proxyFormikSubmission,
  isInitialValid:   ({ values }) => validationSchema.isValidSync(values),
}

export default withFormik(formikConfig)(asFormStep(CredentialsChunk))



// WEBPACK FOOTER //
// ./src/components/forms/CredentialsForm.tsx